webpackJsonp([12],{

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leancloud_storage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leancloud_storage__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: this.$store.getters.user.email || '',

      sent: false,
      rebind: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['user'])),
  validators: {
    email: {
      debounce: 300,
      validator: function validator(v) {
        return __WEBPACK_IMPORTED_MODULE_2_simple_vue_validator__["Validator"].value(v).required('邮箱必填').email('请输入有效的邮箱地址');
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['updateUser']), {
    onBack: function onBack() {
      this.$router.go(-1);
    },
    bind: function bind() {
      var _this = this;

      var user = __WEBPACK_IMPORTED_MODULE_3_leancloud_storage___default.a.User.current();
      if (!this.rebind && this.user.emailVerified) {
        return;
      } else if (user.getEmail() && this.sent) {
        user.fetch().then(function () {
          if (user.get('emailVerified')) {
            _this.$toast('已完成绑定');
            _this.updateUser({ emailVerified: true });
            _this.$router.go(-1);
          } else {
            _this.$toast('未完成绑定');
          }
        });
      } else {
        this.$validate().then(function (isSuccess) {
          if (isSuccess) {
            if (_this.email === user.get('email')) {
              return _this.$toast('邮箱并未修改');
            }
            user.setEmail(_this.email).save().then(function () {
              _this.updateUser({ email: _this.email });
              __WEBPACK_IMPORTED_MODULE_3_leancloud_storage___default.a.User.requestEmailVerify(_this.email).then(function (result) {
                _this.sent = true;
                _this.$toast('验证邮件已发送，请前往邮箱查看');
              }).catch(function () {
                _this.$toast('验证邮件发送失败');
              });
            }).catch(function (err) {
              _this.$toast(err.message || '验证邮件发送失败');
            });
          }
        });
      }
    }
  })
});

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": "",
      "prevent-back": ""
    },
    on: {
      "back": _vm.onBack
    }
  }, [_vm._v("绑定邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "scrollable container flex-1 flex flex-row"
  }, [_c('form', {
    staticClass: "flex-1",
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.bind($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "请输入要绑定的邮箱",
      "autofocus": "",
      "readonly": !_vm.rebind && _vm.user.emailVerified
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [(_vm.validation.hasError('email')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('email')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    directives: [{
      name: "longpress",
      rawName: "v-longpress",
      value: (function () { return _vm.rebind = true; }),
      expression: "()=>rebind=true"
    }],
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("\n        " + _vm._s(!_vm.rebind && _vm.user.emailVerified ? '邮箱已绑定，长按开始重新绑定' : (_vm.sent ? '我已完成绑定' : '绑定邮箱')) + "\n      ")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/12.5aea1192c8843a82cd8e.js